export interface GetBetaProgramsResponse {
  availablePrograms: Array<BetaProgramItem>;
}

export interface UpdateEnrollmentStateResponse {
  success: boolean;
}

export interface BetaProgramItem {
  programName: string;
  enrolled: boolean;
  programLink: string;
  type: number;
  hasFeedback: boolean;
}

export interface BetaProgramFeedbackOptions {
  subject: string;
  template: string;
  mailTo: string;
}

export enum BetaProgramsEvents {
  ENROLL = 'enroll',
  OPTOUT = 'opt-out',
  ATTEMPT_ENROLLMENT = 'attempt-enrollment',
}
